package com.example.crashbit

import kotlinx.coroutines.*
import kotlin.random.Random

class CpuBarnesHutBackend : PhysicsBackend {
    
    override suspend fun applyPhysics(
        bodies: MutableList<SpaceBody>,
        stars: MutableList<SpaceBody>,
        nebulae: List<Nebula>,
        deltaTime: Float,
        config: SimulationConfig,
        pool: QuadNodePool, // V1.2: Pass persistent pool
        isStableMode: Boolean,
        rng: Random?
    ): List<MergerEvent> = coroutineScope {
        PhysicsEngine.applyPhysics(
            bodies, stars, nebulae, deltaTime, config, pool, isStableMode, rng
        )
    }
}
